const data = {
  available: false,
  renderFulltime: false,
  renderConsulting: false
};

export default data;